import cookie from '../cookie/cookie'
import query from './src/query'

const sources = [
  {
    name: 'futm_component_flow',
  },
  {
    name: 'futm_component_acquisition',
    noOverwrite: true,
  },
]

const mappedToCookie = () => {
  sources.forEach(({ name: nameSource, noOverwrite }) => {
    const queryValue = query.getByName(nameSource)
    if (!queryValue) return

    const hasValue = cookie.get(nameSource)

    if (hasValue && noOverwrite) return
    cookie.set(nameSource, queryValue)
  })
}

const createFirstAndLastPage = () => {
  const blocklist = /\/(account|verificar-identidade|minha-conta|planos)/g
  const pageCurrent = window.location.pathname
  const hasFirstPage = cookie.get('futm_first_page')

  if (!hasFirstPage) {
    cookie.set('futm_first_page', pageCurrent)
  }

  if (!pageCurrent.match(blocklist)) {
    cookie.set('futm_last_page', pageCurrent)
  }
}

const setAcquisition = (value) => {
  const hasValue = cookie.get('futm_component_acquisition')
  if (hasValue) return
  cookie.set('futm_component_acquisition', value)
}

const setEventListenerFlow = () => {
  document.addEventListener('click', ({ target }) => {
    const targetFlow = target.closest('[data-tracker-flow]')
    if (!targetFlow) return

    const value = targetFlow.getAttribute('data-tracker-flow')
    cookie.set('futm_component_flow', value)
  })
}

const removeAcquisition = () => {
  cookie.delete('futm_component_acquisition')
}

const mount = () => {
  mappedToCookie()
  createFirstAndLastPage()
}

export default {
  mount,
  setAcquisition,
  setEventListenerFlow,
  removeAcquisition,
}
